export function isSwedishVersion() {
    return window.location.hostname.endsWith(".se");
}
